import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Card, Grid } from '@material-ui/core'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import SingleFileDisplay from '../../Form/SingleFileDisplay'
import { getProjectDetails } from '../../../actions/projectActions'
import { PROJECT_DOCUMENT_SIGNED_RESET } from '../../../constants/projectConstants'
import SignAcceptanceCriteria from './SignAcceptanceCriteria'

const SignAcceptanceCriteriaRevision = ({ file }) => {
  const dispatch = useDispatch()

  const [showModal, setShowModal] = useState(false)

  const { project } = useSelector((state) => state.projectDetails)
  const { success } = useSelector((state) => state.projectDocumentSigned)

  useEffect(() => {
    if (success) {
      dispatch(getProjectDetails(project._id))
      dispatch({ type: PROJECT_DOCUMENT_SIGNED_RESET })
      setShowModal(false)
    }
  }, [success, dispatch, project])

  return (
    <>
      <Grid item xs={12}>
        <Card className="p-16 m-t-24 m-b-16">
          <div className="flex">
            <p className="primary m-b-5">Revision available: </p>
          </div>

          <SingleFileDisplay file={file} />

          <div className="flex flex-end m-t-16">
            <Button
              variant="contained"
              color="primary"
              onClick={() => setShowModal(true)}
            >
              Sign
            </Button>
          </div>
        </Card>
      </Grid>

      <ModalPopUp
        title="Sign revision"
        setShowModal={setShowModal}
        showModal={showModal}
        variant="wide full tall"
      >
        <SignAcceptanceCriteria noCollapse={true} />

        <div className="flex flex-end m-t-40">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
        </div>
      </ModalPopUp>
    </>
  )
}

export default SignAcceptanceCriteriaRevision
